import { LitElement, html } from "lit";
import { supplierReviewsStyles } from "js/sharedStyles/supplierReviews.js";

class WJSupplierReviews extends LitElement {
  static get properties() {
    return {
      userRatings: {
        type: Object,
        attribute: "data-user-ratings",
      },
    };
  }
  static styles = [supplierReviewsStyles];

  render() {
    let ratings = this.userRatings;

    const reviewPercentage = ratings?.additonalCustomerRatings.averagePercent ? Math.ceil(ratings?.additonalCustomerRatings.averagePercent) : null;
    const reviewRating = (parseFloat(reviewPercentage) / 10).toString().split(".");

    if (!ratings) {
      return html``;
    }
    const totalReviews = new Intl.NumberFormat('de-DE')
    const ratingsTitle = ratings.caption.text;
    const acr = ratings.additonalCustomerRatings;
    return html`
  <h5 class="mb-">${ratingsTitle}</h5>

<div class="layout layout--flush">
  <div class="layout__item c-rating-wrapper pv- ph">
    <div class="u-bg-color-grey--x-light u-border-radius-">

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center u-font-weight--bold">Paketbewertung<span class="c-icon-info"></span></div>
        <div class="c-tooltip">
        </div>
        <div class="layout__item u-1/4 u-text-align--center pv-">
          <span class="c-rating-total c-spec c-spec--amount">
            ${reviewRating[0]}<span class="c-spec__decimals">.${reviewRating[1]}</span>
            <span class="c-rating-total__svg"><svg viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M28.195 58.036l-1.345.559a5.354 5.354 0 01-6.175-1.522l-.93-1.12a6 6 0 00-4.083-2.143l-1.45-.13a5.354 5.354 0 01-4.76-4.217l-.304-1.424a6 6 0 00-2.619-3.794l-1.224-.789A5.354 5.354 0 013.05 37.51l.393-1.401a6 6 0 00-.556-4.577l-.717-1.267a5.354 5.354 0 01.767-6.314l1-1.059a6 6 0 001.634-4.31l-.046-1.456a5.354 5.354 0 013.613-5.234l1.377-.473a6 6 0 003.451-3.057l.635-1.31a5.354 5.354 0 015.632-2.956l1.439.221a6 6 0 004.477-1.103l1.171-.865a5.354 5.354 0 016.36 0l1.171.865a6 6 0 004.477 1.103l1.44-.221a5.354 5.354 0 015.63 2.956l.636 1.31a6 6 0 003.45 3.057l1.378.473a5.354 5.354 0 013.613 5.234l-.046 1.455a6 6 0 001.635 4.311l1 1.059a5.354 5.354 0 01.766 6.314l-.717 1.267a6 6 0 00-.556 4.577l.393 1.401a5.354 5.354 0 01-2.255 5.947l-1.224.789a6 6 0 00-2.62 3.794l-.303 1.424a5.354 5.354 0 01-4.76 4.218l-1.45.13a6 6 0 00-4.083 2.142l-.93 1.12a5.354 5.354 0 01-6.175 1.522l-1.345-.56a6 6 0 00-4.61 0z"
                  fill="#61A38D" class="u-svg-fill"></path>
                <circle stroke="#F7F7F7" cx="30.5" cy="30.5" r="22" stroke-width="2"></circle>
              </svg></span>
          </span>
        </div>
      </div>
      <hr class="mb- mt0" />

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.price.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.price.percent / 10).toFixed(1)}</span></div>
      </div>

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.service.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.service.percent / 10).toFixed(1)}</span></div>
      </div>

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.switching.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.switching.percent / 10).toFixed(1)}</span></div>
      </div>

    </div>
  </div>
</div>
<div class="mt"><strong>${ratings.switchAgain.percent}%</strong> von <strong>${totalReviews.format(ratings.switchAgain.totalReviews)}</strong> Kunden würden wieder zu diesem Anbieter wechseln.</div>
    `;
  }
}
const initWJSupplierReviews = () => {
  window.customElements.define("wj-supplier-reviews", WJSupplierReviews);
};

export { initWJSupplierReviews };
